import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const TeamsModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t(`Teams`)}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>
          {t(`In single device mode, each new device to join the game will
          automatically create their own team. Players will enter the game as a
          team of one. If you choose the multiple device mode, players will be
          prompted as to whether or not they are creating a new team or joining an
          existing team.`)}
        </p>
        <ul>
          <li>
            {t(`In multiple device mode, if players join an existing team, there is no
            approval or reciprocation required from players already on the team.`)}
          </li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t(`Close`)}
        </Button>
      </div>
    </Modal>
  )
};

export default TeamsModal;
